import React, { useEffect, useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

import { useScrollPosition } from 'contexts/ScrollPositionContext';

interface Props {
    containerRef: React.RefObject<HTMLDivElement>;
}

// Custom replacement for react-router-dom's ScrollRestoration component.
// This supports a custom scrolling container (containerRef), but is currently
// location key-based only (does not support pathname-based scroll restoration yet).
const ScrollRestoration: React.FC<Props> = ({ containerRef }) => {
    const location = useLocation();
    const { savePosition, getPosition } = useScrollPosition();
    const navType = useNavigationType();

    useLayoutEffect(() => {
        if (containerRef.current && navType === 'POP') {
            containerRef.current.scrollTop = getPosition(location.key);
        }
    }, [location.key]);

    useEffect(() => {
        const handleScroll = () => {
            if (containerRef.current) {
                savePosition(location.key, containerRef.current.scrollTop);
            }
        };

        containerRef.current?.addEventListener('scroll', handleScroll);

        return () => {
            containerRef.current?.removeEventListener('scroll', handleScroll);
        };
    }, [containerRef, location.key, savePosition]);

    return null;
};

export default ScrollRestoration;
